import { ReactNode } from 'react';

import { NetworkPole } from '../../../../../../api/theHive/redeProto/types';
import { csatColor, heatColor } from '../../theme/tokens';
import {
  EMPTY_VALUE,
  formatCsat,
  formatInt,
  formatPct,
} from '../../utils/format';
import { StatusPill } from '../StatusPill';
import {
  Block,
  BlockLabel,
  EmptyHint,
  Head,
  MetricLabel,
  MetricRow,
  MetricValue,
  Name,
  Sub,
  Wrap,
} from './styles';

interface PoleDetailProps {
  pole: NetworkPole | undefined;
  footer?: ReactNode;
}

export function PoleDetail({ pole, footer }: PoleDetailProps): JSX.Element {
  if (!pole) {
    return <EmptyHint>Selecione um polo para ver os detalhes.</EmptyHint>;
  }

  return (
    <Wrap>
      <Head>
        <div>
          <Name>{pole.name ?? pole.city}</Name>
          <Sub>
            {pole.uf} · {pole.region ?? EMPTY_VALUE}
          </Sub>
        </div>
        <StatusPill classification={pole.classification} />
      </Head>

      <div>
        <MetricRow>
          <MetricLabel>Meta</MetricLabel>
          <MetricValue>{formatInt(pole.goal)}</MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>Credenciados</MetricLabel>
          <MetricValue>{formatInt(pole.accredited)}</MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>Atingimento</MetricLabel>
          <MetricValue color={heatColor(pole.achievement)}>
            {formatPct(pole.achievement)}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>SLA</MetricLabel>
          <MetricValue color={heatColor(pole.sla)}>
            {formatPct(pole.sla)}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>CSAT</MetricLabel>
          <MetricValue color={csatColor(pole.csat)}>
            {formatCsat(pole.csat)}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>Aprovação 1ª revisão</MetricLabel>
          <MetricValue color={heatColor(pole.approval)}>
            {formatPct(pole.approval)}
          </MetricValue>
        </MetricRow>
      </div>

      <Block>
        <BlockLabel>Cidade</BlockLabel>
        {pole.city || EMPTY_VALUE}
      </Block>

      {footer}
    </Wrap>
  );
}
